<div id="svp-player_{{streamKey}}"></div>